// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"91c09325","106":"875d29f4"}[chunkId] + ".chunk.css";
};